<template>
    <dashboard-layout tit="포인트 관리">
        <template slot="contents">
            <point-card v-on="{ search }" />
            <v-tabs class="my-12 my-lg-20 v-tabs--underline">
                <v-tab :to="`${baseUrl}/list`">포인트</v-tab>
                <v-tab :to="`${baseUrl}/card`">신용카드 거래</v-tab>
                <v-tab :to="`${baseUrl}/bank`">무통장입금 거래</v-tab>
            </v-tabs>
            <v-divider class="primary border-2" />
            <v-tabs-items :value="tab">
                <v-tab-item value="list" class="fill-height">
                    <point-list />
                </v-tab-item>
                <v-tab-item value="card" class="fill-height">
                    <card-order-list />
                </v-tab-item>
                <v-tab-item value="bank" class="fill-height">
                    <bank-order-list />
                </v-tab-item>
            </v-tabs-items>
        </template>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import PointCard from "@/components/dashboard/company/point/point-card.vue";
import PointList from "@/components/dashboard/company/point/point-list.vue";
import CardOrderList from "@/components/dashboard/company/point/card-order-list.vue";
import BankOrderList from '@/components/dashboard/company/point/bank-order-list.vue';

const baseUrl = "/dashboard/point";
const tab__initial = "list";

export default {
    components: {
        DashboardLayout,
        PointCard,
        PointList,
        CardOrderList,
        BankOrderList,
    },
    props: {
        tab: { type: String, default: tab__initial },
    },
    data: () => ({
        baseUrl,
    }),
    mounted() {
        this.syncPath();
    },
    methods: {
        async syncPath() {
            const path = `${baseUrl}/${tab__initial}`;
            if (this.$route.path != path) this.$router.replace({ path });
        },

        search() {
            const path = "/dashboard/point/list";
            if (this.$route.path != path) this.$router.push({ path });
            this.$refs["point-list"]?.search?.();
        },
    },
};
</script>

<style></style>
